<div class="modal-header text-center border-bottom-0">
    <h4 class="modal-title display-inline-block ">kies puntensysteem</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">    

    <ul class="list-group">
        <li class="list-group-item pointer" ngClass="{'active': currentBadgeCategory() === undefined}"
            (click)="modal.close(undefined)">
            <label class="form-check-label align-middle" for="radio-points">
                <app-superelf-trophy-icon size="2x" [leagueName]="leagueName"></app-superelf-trophy-icon>
                <span class="ms-2"> punten</span></label>
        </li>
        @for(choosableBadgeCategory of choosableBadgeCategories; track choosableBadgeCategory) {
            <li class="list-group-item pointer" ngClass="{'active': currentBadgeCategory() === choosableBadgeCategory}" 
                (click)="modal.close(choosableBadgeCategory)">
                <label class="form-check-label pointer" for="radio-{{choosableBadgeCategory}}">
                    <app-superelf-badge-icon [badgeCategory]="choosableBadgeCategory"></app-superelf-badge-icon>
                    <span class="ms-1">{{nameService.getBadgeCategoryName(choosableBadgeCategory)}}</span>
                </label>
            </li>
        }
    </ul>
</div>